import { render, staticRenderFns } from "./PaginationCustomer.vue?vue&type=template&id=7f0a90a6"
import script from "./PaginationCustomer.vue?vue&type=script&lang=js"
export * from "./PaginationCustomer.vue?vue&type=script&lang=js"
import style0 from "./PaginationCustomer.vue?vue&type=style&index=0&id=7f0a90a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports